import type {
  FilterGroup,
  FilterInput,
} from '@/components/publicSearch/constants';
import { isFilterInputIncompleteForQuery } from '@/components/publicSearch/search/searchFilterEbvExpansion';

/**
 * True when the active filter source (grouped editor rows when present,
 * otherwise flat filters) contains at least one complete condition. Empty
 * editor rows are not a search.
 */
export function hasFilterCriteria(
  filters: FilterInput[],
  filterGroups: FilterGroup[],
): boolean {
  const activeFilters = filterGroups.length
    ? filterGroups.flatMap((group) => group.filters)
    : filters;
  return activeFilters.some(
    (filter) => !isFilterInputIncompleteForQuery(filter),
  );
}
